import { render } from "./UninstallCardModal.vue?vue&type=template&id=371ef5e4&scoped=true"
import script from "./UninstallCardModal.vue?vue&type=script&lang=js"
export * from "./UninstallCardModal.vue?vue&type=script&lang=js"

import "./UninstallCardModal.vue?vue&type=style&index=0&id=371ef5e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371ef5e4"]])

export default __exports__